import React, { useEffect, useState } from "react";
import axios from "axios";

const MAX_CREDITO = 3000;

const ListadoClientes = () => {
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredClientes, setFilteredClientes] = useState([]);

  const BASE_URL = "https://api.adipanperu.com/api/registro";

  useEffect(() => {
    fetchClientes();
  }, []);

  const fetchClientes = async () => {
    try {
      const res = await axios.get(BASE_URL);
      const data = Array.isArray(res.data) ? res.data : res.data.data;
      setClientes(data);
      setFilteredClientes(data);
    } catch (error) {
      console.error("Error al obtener clientes:", error);
      alert("No se pudieron cargar los clientes.");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
    const filtered = clientes.filter(
      (c) =>
        c.name?.toLowerCase().includes(value) ||
        c.dni?.toString().includes(value)
    );
    setFilteredClientes(filtered);
  };
  const updateCredito = async (clienteId, newCredito, nuevoCreditoActivo = null) => {
  const cliente = clientes.find((c) => c.id === clienteId);
  if (!cliente) return;

  const credito = Number(newCredito);
  const creditoActivo =
    nuevoCreditoActivo !== null
      ? nuevoCreditoActivo
      : cliente.creditoActivo;

  console.log("ENVIANDO AL BACKEND:", {
    clienteId,
    credito,
    creditoActivo,
  });

  try {
    const res = await axios.put(`${BASE_URL}/${clienteId}/credito`, {
      credito,
      creditoActivo,
    });

    console.log("RESPUESTA BACKEND:", res.data);

    if (res.status === 200) {
      setClientes((prev) =>
        prev.map((c) =>
          c.id === clienteId
            ? { ...c, credito, creditoActivo }
            : c
        )
      );
    }
  } catch (error) {
    console.error("ERROR BACKEND:", error);
  }
};
if (loading) return <p>Cargando clientes...</p>;

  return (
    <div className="p-6 w-full">
      <h1 className="text-2xl font-bold mb-4">🧑🏻‍🤝‍🧑🏻 Listado de Clientes</h1>
      <input
        type="text"
        placeholder="Buscar por nombre o DNI..."
        value={searchTerm}
        onChange={handleSearch}
        className="border border-gray-300 rounded-md px-3 py-1 mt-2 sm:mt-0 w-full sm:w-64 focus:ring focus:ring-blue-200"
      />
      {filteredClientes.length === 0 ? (
        <p className="italic text-gray-500">No hay clientes registrados.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white rounded shadow">
            <thead>
              <tr>
                <th className="border px-2 py-2">ID Usuario</th>
                <th className="border px-2 py-2">Nombre</th>
                <th className="border px-2 py-2">DNI</th>
                <th className="border px-2 py-2">Teléfono</th>
                <th className="border px-2 py-2">Dirección</th>
                <th className="border px-2 py-2">Región</th>
                <th className="border px-2 py-2">Provincia</th>
                <th className="border px-2 py-2">Distrito</th>
                <th className="border px-2 py-2">Email</th>
                <th className="border px-2 py-2">Crédito</th>
                <th className="border px-2 py-2">Crédito Activo</th>
              </tr>
            </thead>
            <tbody>
              {filteredClientes.map((cliente) => (
                <tr key={cliente.id} className="hover:bg-gray-100">
                  <td className="border px-2 py-1 text-center">{cliente.idUsuario || cliente.id}</td>
                  <td className="border px-2 py-1">{cliente.name || cliente.nombre}</td>
                  <td className="border px-2 py-1">{cliente.dni}</td>
                  <td className="border px-2 py-1">{cliente.phone || cliente.telefono}</td>
                  <td className="border px-2 py-1">{cliente.direccion}</td>
                  <td className="border px-2 py-1">{cliente.region}</td>
                  <td className="border px-2 py-1">{cliente.provincia}</td>
                  <td className="border px-2 py-1">{cliente.distrito}</td>
                  <td className="border px-2 py-1">{cliente.email}</td>
                  <td className="border px-2 py-1 text-center">
                    <input
                      type="number"
                      min="0"
                      value={cliente.credito || 0}
                      onChange={(e) =>
                        updateCredito(cliente.id, Number(e.target.value))
                      }
                      className="border rounded px-2 py-1 w-24 text-center"
                    />

                  </td>
                  <td className="border px-4 py-2 text-center">
                    <input
                      type="checkbox"
                      checked={!!cliente.creditoActivo}
                      onChange={(e) => {
                        const checked = e.target.checked;

                        const nuevoCredito = checked ? 1 : 0;

                        // 🔥 Actualización inmediata en UI
                        setClientes((prev) =>
                          prev.map((c) =>
                            c.id === cliente.id
                              ? { ...c, creditoActivo: checked, credito: nuevoCredito }
                              : c
                          )
                        );

                        setFilteredClientes((prev) =>
                          prev.map((c) =>
                            c.id === cliente.id
                              ? { ...c, creditoActivo: checked, credito: nuevoCredito }
                              : c
                          )
                        );

                        // 🔥 Enviar al backend
                        updateCredito(cliente.id, nuevoCredito, checked);
                      }}
                    />

                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ListadoClientes;

